import { StatusKey } from '@/Enums/Agencies/StatusKey.enum';
import { IAgencyFormData } from '@/Interfaces/Agency.interface';

export const AGENCIES_STATUS_LABELS = [
  { name: StatusKey.ALL, label: 'All' },
  { name: StatusKey.ACTIVE, label: 'Active' },
  { name: StatusKey.INACTIVE, label: 'Inactive' },
] as const;

export const BASE_TAB_ID = 'agencies-filter-tab';

export const DEFAULT_AGENCY: IAgencyFormData = {
  name: '',
  client: null,
  advertisers: [],
};
